export default __webpack_public_path__ + "static/media/speechAndDrama.ceb5ca42.png";